import {RootLayout, Skeleton as RsnSkeleton} from '@raison/ui-kit';
import React, {ReactNode} from 'react';
import {Link} from 'react-router';
import {SkeletonPageLayout} from '~/entities/fallbacks';
import {getPagesContent} from './content';
import * as cardsCss from './css/cards.css';
import {TariffFlag, TariffName} from './types';

const cls = {
    ...cardsCss,
};

export function TariffsPreviewScreen({
    activeTariff,
    pathToTariff,
}: {
    activeTariff: TariffName;
    pathToTariff: (tariff: TariffName) => string;
}) {
    const {attributes: tariffsAttributes} = getPagesContent();
    const allTariffs = Object.values(tariffsAttributes);

    const visibleTariffs = (active: TariffName) => {
        const activeIsExclusive = tariffsAttributes[active].flags.includes(TariffFlag.Exclusive);
        if (activeIsExclusive) {
            return allTariffs.filter(({flags}) => flags.includes(TariffFlag.Exclusive));
        } else {
            return allTariffs;
        }
    };

    return (
        <Layout>
            {visibleTariffs(activeTariff).map(({title, subtitle, shortDescription}) => (
                <Link key={title} to={pathToTariff(title)}>
                    <TariffCard
                        tariffName={title}
                        isCurrent={activeTariff === title}
                        subheading={subtitle}
                        details={shortDescription}
                    />
                </Link>
            ))}
        </Layout>
    );
}

function Layout({children}: {children: ReactNode}) {
    return (
        <RootLayout common title='Account upgrade'>
            {children}
        </RootLayout>
    );
}

export namespace TariffsPreviewScreen {
    export const Skeleton = ({isError}: {isError?: boolean}) => (
        <SkeletonPageLayout title='Account upgrade' stopped={isError}>
            <TariffCard.Skeleton />
            <TariffCard.Skeleton />
            <TariffCard.Skeleton />
        </SkeletonPageLayout>
    );
}

function TariffCard({
    tariffName,
    subheading,
    isCurrent,
    details,
}: {
    tariffName: TariffName;
    subheading: string;
    details: string;
    isCurrent: boolean;
}) {
    return (
        <div className={cls.card[tariffName]}>
            <div className='p-4 text-neutral-10'>
                <h4 className='fv-heading-m'>{tariffName}</h4>
                <h5 className='fv-text-m-regular'>{subheading}</h5>
            </div>
            <div className={cls.details}>
                <span>{details}</span>
                {isCurrent && <span className={cls.badge}>Current plan</span>}
            </div>
        </div>
    );
}

TariffCard.Skeleton = function Skeleton() {
    return <RsnSkeleton height={120} borderRadius={16} />;
};
